import { reactive } from 'vue'
import Api from '../api/Notification'

const state = reactive({
    loading: false,
    notifications: [],
    student_id: null,
    contact_id: null,
})

function init() {
    state.loading = true;
    return Api.Get().then(res => {
        state.loading = false;
        state.student_id = res.data.student_id;
        state.contact_id = res.data.contact_id;
        state.notifications = res.data.notifications;
    })
}

function markAsRead() {
    return Api.MarkAsRead().then(res => {
        if (res.success) {
            this.init();
        }
    });
}

function isLoading() {
    return state.loading;
}

function getNotifications() {
    return state.notifications;
}

function getStudentUnreadMessages() {
    return state.notifications.filter(noti => {
        return noti.user_id === state.student_id && noti.read === '0000-00-00 00:00:00';
    }).length;
}

function isContact() {
    return state.contact_id !== null;
}

export default {
    state,
    init,
    markAsRead,
    isLoading,
    getNotifications,
    getStudentUnreadMessages,
    isContact,
}
